import { ProtocolContentData } from "../../protocol";
export default class SoundingsData extends ProtocolContentData {
    soundings;
    freeText;
    constructor() {
        super();
        this.soundings = [];
    }
}
//# sourceMappingURL=SoundingsData.js.map